// Copyright ©️ 2026 eVolve MEP, LLC

import type { ALL_MODULE_ROUTES, ShopNavigationRoute } from 'app/ModuleRoutes';
import type { EvolveIconName } from 'assets/icons/EvolveIcon';
import type { PageTitle } from 'components/Mantine/Navigation/types';

/** Shop is the only module, now */
export const moduleRoute = 'shop';

export type NavOption = {
  label: PageTitle | string;
  route: ShopNavigationRoute & keyof typeof ALL_MODULE_ROUTES;
};

export const GLOBAL_NAVIGATION_MENU = [
  {
    label: 'Management',
    icon: 'LightBulb',
    options: [
      {
        label: 'Customers',
        route: '/evolve-customers',
      },
      {
        label: 'Revit Downloads',
        route: '/revit-downloads',
      },
      {
        label: 'Product Features',
        route: '/product-features',
      },
    ],
  },
  {
    label: 'Insights',
    icon: 'Insights',
    options: [
      {
        label: 'VDC',
        route: '/analytics',
      },
      {
        label: 'Materials',
        route: '/materials-analytics',
      },
      {
        label: 'Shop',
        route: '/insights',
      },
      {
        label: 'Task Data',
        route: '/task-data',
      },
    ],
  },
  {
    label: 'Production',
    icon: 'ModelBrowser',
    options: [
      {
        label: 'Work Orders',
        route: '/work-orders',
      },
      {
        label: 'Shipping Orders',
        route: '/shipping-orders',
      },
      {
        label: 'Tasks',
        route: '/tasks',
      },
      {
        label: 'Bill of Materials',
        route: '/bill-of-materials',
      },
      {
        label: 'Time Tracking',
        route: '/time-tracking',
      },
      {
        label: 'Fabrication',
        route: '/fabrication',
      },
      {
        label: 'Spooling',
        route: '/spooling',
      },
      {
        label: 'Model Browser',
        route: '/model-browser',
      },
    ],
  },
  {
    label: 'Company',
    icon: 'Facility',
    options: [
      {
        label: 'Facilities',
        route: '/facilities',
      },
      {
        label: 'Projects',
        route: '/projects',
      },
      {
        label: 'Catalog',
        route: '/catalog-setup',
      },
      {
        label: 'Shop Properties',
        route: '/shop-properties',
      },
      {
        label: 'Members',
        route: '/company-members',
      },
      {
        label: 'Licenses',
        route: '/licenses',
      },
      {
        label: 'Content Request',
        route: '/content-request',
      },
    ],
  },
] as const satisfies {
  label: string;
  icon: EvolveIconName;
  options: [NavOption, ...NavOption[]];
}[];

export type GlobalNavigationItemLabel =
  | (typeof GLOBAL_NAVIGATION_MENU)[number]['label']
  | (typeof GLOBAL_NAVIGATION_MENU)[number]['options'][number]['label'];
